// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "a4ec754ed45f39bc227ff5fa68489a65dc65d88c/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};